module.exports = __webpack_public_path__ + "img/shop_C_5.88a8ad4c.png";